// Guard against re-declaration during hot reload
if (!customElements.get('tooltip-modal')) {
  class Tooltip extends HTMLElement {
    constructor() {
      super();
      this.tooltipButton = this.querySelector('.tooltip__button');
      this.tooltipContent = this.querySelector('.tooltip__content');
      this.hideTimeout = null;
    }

    connectedCallback() {
      // Show tooltip on button hover
      this.tooltipButton?.addEventListener('mouseenter', () => {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }

        // Close all other open tooltips
        document.querySelectorAll('tooltip-modal.tooltip--active').forEach((tooltip) => {
          if (tooltip !== this) {
            tooltip.classList.remove('tooltip--active');
          }
        });

        // Open tooltip
        this.classList.add('tooltip--active');
      });

      // Keep tooltip open when hovering over the button
      this.tooltipButton?.addEventListener('mouseleave', () => {
        this.hideTimeout = setTimeout(() => {
          this.classList.remove('tooltip--active');
        }, 200);
      });

      // Keep tooltip open when hovering over the content
      this.tooltipContent?.addEventListener('mouseenter', () => {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
      });

      // Hide tooltip when leaving the content
      this.tooltipContent?.addEventListener('mouseleave', () => {
        this.hideTimeout = setTimeout(() => {
          this.classList.remove('tooltip--active');
        }, 200);
      });
    }
  }

  customElements.define('tooltip-modal', Tooltip);
}